export default __webpack_public_path__ + "static/media/projetos3-imagem.2e668ea2.svg";